import { createUseStyles } from "react-jss";
import { routeToHash } from "../../routes";
import type { VetBoatsTheme } from "../../theme";

const useStyles = createUseStyles((theme: VetBoatsTheme) => ({
  footer: {
    maxWidth: 760,
    margin: "0 auto",
    padding: "20px 16px 28px",
    fontSize: 13,
    lineHeight: 1.5,
    color: theme.color.muted,
    textAlign: "center",
  },
  // On the sign-in backdrop the footer can straddle dark and light areas, so give it a backing.
  boxed: {
    marginTop: 18,
    padding: "12px 16px",
    background: "rgba(255, 255, 255, 0.92)",
    borderRadius: theme.radius,
    boxShadow: theme.shadow,
  },
}));

/** Site-wide statement that VetBoats has no connection to any organization. */
export const SiteFooter = ({ boxed = false }: { boxed?: boolean }) => {
  const classes = useStyles();
  return (
    <footer className={`${classes.footer} ${boxed ? classes.boxed : ""}`}>
      VetBoats is an independent, private arrangement between individual boat
      owners and borrowers. It is not sponsored, endorsed, operated, or funded
      by any veterans' service organization, military unit, government agency,
      charity, or other group.{" "}
      <a href={routeToHash({ page: "agreement" })}>User Agreement</a>
    </footer>
  );
};
